export type DividerLine =
    'None' |
    'Above' |
    'Below' |
    'Both';

export class DividerLines {
    public static readonly NONE: DividerLine = 'None';
    public static readonly ABOVE: DividerLine = 'Above';
    public static readonly BELOW: DividerLine = 'Below';
    public static readonly BOTH: DividerLine = 'Both';
}
